import { Components, Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Popover(theme: Theme): Components<Theme> {
  return {
    MuiPopover: {
      styleOverrides: {
        paper: {
          boxShadow: theme.customShadows.z12
        }
      }
    }
  };
}
